import React, { Fragment } from 'react';
import { Alert } from 'reactstrap';

class CalendarDispositionAlert extends React.Component { 

    componentDidMount() {
        // this.myRef.current.play();
      }

      saveDispositionStatus=(e,data, index)=>{
          e.preventDefault();
        this.props.saveDispositionStatus(e.target.value, data, index)
      }

      onDismiss=(data,index)=>{
        this.props.saveDispositionStatus(null, data, index)
      }

    extractCalendarDispositionNotify = (data,index) =>
        <Fragment><p className="text-center  mb-0">
            <span className="alert-text text-sm ml-1">
                Your appointment schedule <strong>{data.title}</strong> has passed. Please select the disposition status below.
            </span>
        </p>
            <p className="text-center mb-0"><select className="form-control-sm" onChange={(e) => this.saveDispositionStatus(e,data,index)} >
                <option value="7">Unselected</option>
                <option value="2">No Show</option>
                <option value="3">Missed</option>
                <option value="4">Rescheduled</option>
                <option value="5">Complete</option>
            </select></p>
        </Fragment>;
        
    render() {
        const { notification,index } = this.props;
        return (
            <Fragment>
                <Alert color="default" isOpen={true} toggle={()=>this.onDismiss(notification.data, index)} fade={false}>                   
                    {this.extractCalendarDispositionNotify(notification.data, index)}
                </Alert>
            </Fragment>
        )
    }
};

export default CalendarDispositionAlert

